<template>
    <v-dialog v-model="showDialog" max-width="500">
        <v-card>
            <v-container>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card tile>
                            <v-card-title>
                                Permission details
                            </v-card-title>
                            <v-card-text>
                                <v-text-field
                                    readonly
                                    outlined
                                    dense
                                    label="Permission Name"
                                    v-model="permission.name"
                                >
                                </v-text-field>
                                <v-text-field
                                    readonly
                                    outlined
                                    dense
                                    label="Permission Description"
                                >
                                </v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card tile>
                            <v-card-title>
                                Current assignations [{{ type }}]
                            </v-card-title>
                            <v-card-text>
                                <v-list>
                                    <v-list-item
                                        v-for="item in permission[type]"
                                        :key="item.id"
                                        link
                                    >
                                        <v-list-item-title>
                                            <v-icon
                                                left
                                                :color="item.color ?? 'primary'"
                                            >
                                                mdi-label
                                            </v-icon>
                                            {{ item.name }}
                                        </v-list-item-title>
                                        <v-list-item-action>
                                            <v-btn
                                                icon
                                                color="error"
                                                @click="detachAssignation(item)"
                                            >
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider></v-divider>
                                    <v-list-item>
                                        <v-autocomplete
                                            v-model="newAssignation"
                                            :items="filteredCatalog"
                                            item-text="name"
                                            return-object
                                            label="New Assignation"
                                            prepend-inner-icon="mdi-label"
                                            class=""
                                        >
                                            <template #append-outer>
                                                <v-btn
                                                    color="success"
                                                    text
                                                    @click="attachAssignation"
                                                >
                                                    <v-icon left>
                                                        mdi-content-save
                                                    </v-icon>
                                                    Add
                                                </v-btn>
                                            </template>
                                        </v-autocomplete>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" text @click="close">
                    <v-icon left>mdi-close</v-icon>
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
export default {
    name: 'AssignationsDialog',
    props: {
        value: Boolean,
        permission: Object,
        catalog: Array,
        type: String
    },
    data() {
        return {
            loading: false,
            selected: null,
            newAssignation: '',
            form: {
                name: '',
                description: ''
            }
        };
    },
    computed: {
        showDialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        filteredCatalog() {
            //Filter out the current assignations that already exist on permission[type]
            return this.catalog.filter(item => {
                return !this.permission[this.type].some(
                    assignation => assignation.id === item.id
                );
            });
        }
    },
    watch: {
        showDialog(newVal) {
            if (newVal) {
                this.resetForm();
            }
        }
    },
    methods: {
        async attachAssignation() {
            this.loading = true;
            let attachType = this.type.slice(0, -1);
            let url = `/v2/system/permissions/attach-${attachType}/${this.permission.id}/${this.newAssignation.id}`;
            try {
                await axios
                    .post(url)
                    .then(response => {
                        this.$emit('update', {
                            permission: this.permission,
                            type: this.type,
                            assignation: response.data
                        });
                        this.$store.dispatch('setSnackbar', {
                            text: 'Permission updated',
                            color: 'success',
                            timeout: 3000
                        });
                    })
                    .catch(error => {
                        console.error(error);
                    });
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        async detachAssignation(item) {
            let attachType = this.type.slice(0, -1);
            await axios
                .delete(
                    `/v2/system/permissions/detach-${attachType}/${this.permission.id}/${item.id}`
                )
                .then(() => {
                    this.$emit('delete', {
                        permission: this.permission,
                        type: this.type,
                        assignation: item
                    });
                    this.$store.dispatch('setSnackbar', {
                        text: 'Permission updated',
                        color: 'success',
                        timeout: 3000
                    });
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        close() {
            this.showDialog = false;
        },
        resetForm() {
            this.form = {
                name: this.permission.name,
                description: this.permission.description
            };
        }
    }
};
</script>
